export const REMEMBER_ME_STORAGE_KEY = 'authRememberMe'

/** Refresh tokens issued with remember-me last ~30 days (vs 7 days default). */
const REMEMBER_ME_MIN_LIFETIME_DAYS = 25

export function getRememberMeFromStorage(): boolean {
  try {
    return localStorage.getItem(REMEMBER_ME_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export function persistRememberMe(rememberMe: boolean): void {
  try {
    if (rememberMe) {
      localStorage.setItem(REMEMBER_ME_STORAGE_KEY, 'true')
    } else {
      localStorage.removeItem(REMEMBER_ME_STORAGE_KEY)
    }
  } catch {
    // ignore storage errors
  }
}

export function clearRememberMeStorage(): void {
  try {
    localStorage.removeItem(REMEMBER_ME_STORAGE_KEY)
  } catch {
    // ignore storage errors
  }
}

export function inferRememberMeFromRefreshToken(refreshToken: string | null): boolean {
  if (getRememberMeFromStorage()) return true
  if (!refreshToken) return false
  try {
    const parts = refreshToken.split('.')
    if (parts.length !== 3) return false
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')))
    if (typeof payload.exp !== 'number' || typeof payload.iat !== 'number') return false
    const lifetimeDays = (payload.exp - payload.iat) / 86_400
    return lifetimeDays >= REMEMBER_ME_MIN_LIFETIME_DAYS
  } catch {
    return false
  }
}

/** Standard session inactivity window (minutes) vs remember-me (30 days). */
export const STANDARD_SESSION_TIMEOUT_MINUTES = 30
export const REMEMBER_ME_SESSION_TIMEOUT_MINUTES = 30 * 24 * 60

export function resolveSessionTimeoutMinutes(
  rememberMe: boolean,
  standardMinutes: number = STANDARD_SESSION_TIMEOUT_MINUTES
): number {
  return rememberMe ? REMEMBER_ME_SESSION_TIMEOUT_MINUTES : standardMinutes
}
